import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return createStyles({
    containerDatagrid: {
      marginTop: '1rem',
      marginBottom: '3rem',
    },
    datagrid: {
      height: '400px',
    },
  });
});
